// move shopify text element to header (black friday text banner)
if(document.getElementById("shopify-section-template--21431675617570__22f86904-ab03-4b99-9463-c7a6fd85c45a")){

  // get elemn
  let parent = document.querySelector('#shopify-section-template--21431675617570__slideshow');
  let child = document.querySelector('#shopify-section-template--21431675617570__22f86904-ab03-4b99-9463-c7a6fd85c45a');

  // move elem
  parent.appendChild(child);

  // show elem
  setTimeout(() => {
    document.querySelector('#shopify-section-template--21431675617570__22f86904-ab03-4b99-9463-c7a6fd85c45a').style.opacity = "1";
  }, "1000");
}


// TRIGGER Klaviyo (start page slideshow)
document.getElementById("shopify-section-template--21431675617570__slideshow").addEventListener("click", openKlaviyoForm, true);
function openKlaviyoForm() {
  window.location.href = "https://fauxaffairs.com/collections/kunstfell-jacken";
}